import FAPictureCardPicture from './FAPictureCardPicture'
export default FAPictureCardPicture
